duracion_min: 48
faseProduccion: 0
id: 5
preguntas: 5
secciones:
- tipo: teoria
- tipo: quiz-practica
- tipo: recursos
titulo: Automatizar inversiones
